const Footer = () => {
  return (
    <div className="text-center p-3 md:p-4 bg-black text-white text-sm md:text-base">
      © 2026 Aranya Nutraceuticals
    </div>
  );
};

export default Footer;